export const applyDocumentUpdate = (documentUpdate, pageId, value) => {
    documentUpdate ??= { pages: {} };
    documentUpdate.pages[pageId] = value;
    return documentUpdate;
};
